// Sub-category → categories matrix derived from the live categories list (same rule as backend category_matrix.py)
export const buildMatrix = (categories) => {
  const m = {};
  (categories || []).forEach(c => (c.subcategories || []).forEach(s => { (m[s] = m[s] || []).push(c.slug); }));
  return m;
};

const key = (x) => `${x.category}::${x.subcategory || ''}`;

// Union of {category, subcategory} for the given sub-category names, excluding the primary category and already-known entries
export const autoCategories = (matrix, primaryCategory, subNames, exclude = []) => {
  const seen = new Set(exclude.map(key));
  const out = [];
  subNames.filter(Boolean).forEach(sub => (matrix[sub] || []).forEach(slug => {
    const entry = { category: slug, subcategory: sub };
    if (slug !== primaryCategory && !seen.has(key(entry))) { seen.add(key(entry)); out.push(entry); }
  }));
  return out;
};

// Split saved extra_categories into manual rows and matrix-derived (automatic) ones.
// Rows explained by the primary sub-category are automatic; among rows sharing the same sub-category,
// the first one is the admin's manual choice and the others are derived from it.
export const splitExtras = (matrix, primaryCategory, primarySub, extras) => {
  const fromPrimary = new Set(autoCategories(matrix, primaryCategory, [primarySub]).map(key));
  const seenSub = new Set();
  const manual = extras.filter(x => {
    if (!x.category || fromPrimary.has(key(x))) return false;
    if (!x.subcategory) return true;
    const derivable = (matrix[x.subcategory] || []).includes(x.category);
    if (derivable && seenSub.has(x.subcategory)) return false;
    seenSub.add(x.subcategory);
    return true;
  });
  return { manual, auto: autoCategories(matrix, primaryCategory, [primarySub, ...manual.map(x => x.subcategory)], manual) };
};

export const mergeExtras = (manual, auto) => {
  const seen = new Set();
  return [...manual, ...auto].filter(x => x.category && !seen.has(key(x)) && seen.add(key(x)));
};
